module.exports = __webpack_public_path__ + "img/night-wherever-we-go.704d8f71.png";